<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import type { OutstandingRepurchaseAction } from '../../../../../Types/restructuring'
import CardContent from '../../UI/Content/CardContent.vue'

defineProps<{
  action: OutstandingRepurchaseAction
}>()

const { t, n } = useI18n()
</script>

<template>
  <CardContent class="mb-2 pt-4">
    <div class="row">
      <div class="col-md-8">
        <b>{{ t('restructuring.fields.outstandingRepurchase.repurchaseAmount.label') }}</b>
      </div>
      <div class="col-md-4" data-test="outstanding-repurchase-summary-repurchase-amount">
        {{ n(Number(action.repurchaseAmount), 'currency') }}
      </div>
    </div>
  </CardContent>
</template>
